import { render } from "./AddNotificationView.vue?vue&type=template&id=73fff452&scoped=true"
import script from "./AddNotificationView.vue?vue&type=script&lang=js"
export * from "./AddNotificationView.vue?vue&type=script&lang=js"

import "./AddNotificationView.vue?vue&type=style&index=0&id=73fff452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fff452"]])

export default __exports__